module.exports = __webpack_public_path__ + "img/MOA_logo.0630d7cc.png";